const months = state => state.months
const summary = state => state.summary
const statusSummary = state => state.status.summary
const selectedYear = state => state.selectedYear
export default {
    months,
    summary,
    statusSummary,
    selectedYear
}
